import { TD } from '../constants/TDAPP';
import storage from '../utils/storage';
const addEvent = TDAPP.onEvent;



const mutations = {
    /** 下面是产品的一些状态 **/
    // 设置产品code
    setProductCode(store, productCode) {
        store.productInfo.productCode = productCode;
        storage.set('productInfo', JSON.stringify(store.productInfo));
    },
    // 设置产品pdf
    setAllPdfFile(store, allPdfFile) { //
        store.productInfo.allPdfFile = allPdfFile;
        storage.set('productInfo', JSON.stringify(store.productInfo));
    },
    // 设置产品保障范围
    setInsuranceScope(store, insuranceScope) { //
        store.productInfo.insuranceScope = insuranceScope;
        storage.set('productInfo', JSON.stringify(store.productInfo));
    },
    // 设置保障期限
    setTimeLimit(store, timeLimit) {
        store.insureInfo.timeLimit = timeLimit;
        storage.set('insureInfo',JSON.stringify(store.insureInfo));
    },
    // 设置银行信息
    setBankInfo (store,bankInfo) {
        store.insureInfo.bankInfo = bankInfo;
        storage.set('insureInfo', JSON.stringify(store.insureInfo));
    },
    /** 下面是投保录入的一些状态 **/
    // 保存被保人信息
    setInsuredInfo(store, insuredInfo) {
        store.insureInfo.insuredInfo = insuredInfo;
        storage.set('insureInfo', JSON.stringify(store.insureInfo));
    },
    // 保存投保人信息
    setHolderInfo(store, holderInfo) {
        store.insureInfo.holderInfo = holderInfo;
        storage.set('insureInfo', JSON.stringify(store.insureInfo));
    },
    // 设置confirmSubmitId
    setConfirmSubmitId(store, confirmSubmitId) {
        store.insureInfo.confirmSubmitId = confirmSubmitId;
        storage.set('insureInfo', JSON.stringify(store.insureInfo));
    },
    // 设置confirmSubmitId
    setTotalPrice(store, totalPrice) {
        store.insureInfo.totalPrice = totalPrice;
        storage.set('insureInfo', JSON.stringify(store.insureInfo));
    },
    // 设置保单价格
    setInsurePrice(store, price) {
        store.insureInfo.price = price;
        storage.set('insureInfo', JSON.stringify(store.insureInfo));
    },
    // 试算项
    setCountPrice: (store , information)=>{
        store.information = { ...store.information, ...information };
        storage.set('information', JSON.stringify(store.information));
    },
    setChargeYear: (store , chargeYear)=>{
        store.information = { ...store.information, chargeYear };
        storage.set('information', JSON.stringify(store.information));
    },
    setAmount: (store , amount)=>{
        store.information = { ...store.information, amount:  amount + '0000' };
        storage.set('information', JSON.stringify(store.information));
    },

    /** 下面是投保身份证录入的一些状态 **/
    /**
     * 设置投保人身份证图片
     * @param store
     * @param key {uploadImageBack | uploadImageFront}
     * @param value
     */
    setHolderIdCardInfoByUploadImage: (store, { key, value }) => {
        store.insuredIdCardUploadInfo.holder[key] = { category: key, ...value };
        storage.set('insuredIdCardUploadInfo', JSON.stringify(store.insuredIdCardUploadInfo));
    },

    /**
     * 设置被保人身份证图片
     * @param store
     * @param key {uploadImageBack | uploadImageFront}
     * @param value 值
     * @param index 第几个
     */
    setInsurersIdCardInfoByUploadImage: (store, { key, value, index = 0 }) => {
        store.insuredIdCardUploadInfo.insurers[index][key] = { category: key, ...value };
        storage.set('insuredIdCardUploadInfo', JSON.stringify(store.insuredIdCardUploadInfo));
    },

    /**
     * 存储下单流程
     */
    setOrderProcessUploadImage: (store, { key , value }) => {
        // alert('到这了');
        // console.log(key,value);
        store.OrderProcessUploadInfo[key] = { processName: key, imageUrl: value };
        storage.set('OrderProcessUploadInfo', JSON.stringify(store.OrderProcessUploadInfo));
    },

    // 登录页
    setLoginPhone: (store, phone) => {
        store.login.phone = phone;
        storage.set('login', JSON.stringify(store.login));
    },

};

TD.forEach((v) => {
    mutations[v.eventId] = (state, value) => {
        value = value || '';
        const params = v.eventParmas(value.id || -1), label = v.eventLabel(value) || params.eventName;
        addEvent(v.eventId, label, params);
    };
});

export {
    mutations
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js